import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssociateSubscriberComponent } from './associate-subscriber/associate-subscriber.component';
import { HeaderComponent } from './header/header.component';
import { ToastComponent } from './toast/toast.component';
import { UploadFileComponent } from './upload-file/upload-file.component';
import { VerifySignatureComponent } from './verify-signature/verify-signature.component';
import { FormsModule } from '@angular/forms';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { RouterModule } from '@angular/router';
import { ModalComponent } from './modal/modal.component';
import { SignatureInputComponent } from './signature-input/signature-input.component';
import { SignaturePadModule } from 'angular2-signaturepad';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

const components = [
  AssociateSubscriberComponent,
  HeaderComponent,
  ToastComponent,
  UploadFileComponent,
  VerifySignatureComponent,
  ModalComponent,
  SignatureInputComponent
]

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PdfViewerModule,
    RouterModule,
    SignaturePadModule,
    NgbTooltipModule,
    NgbModule
  ],
  declarations: [
    components
  ],
  exports: [
    components
  ]
})
export class ComponentsModule { }
